<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Saving...</p>
</ngx-spinner>
<mat-horizontal-stepper>
    <mat-step *ngFor="let process of allProcesses; let index = index">
        <ng-template matStepLabel>
            <span [ngClass]="process.processName === processName ? 'blinking' : ''">
                {{process.processName}}
            </span>
        </ng-template>
    </mat-step>
</mat-horizontal-stepper>

<h1 class="mat-toolbar">Candidate List of {{panelName}}</h1>

<div class="feedback-details-header-cards">
    <mat-card class="panel-member-header-card">
        <p>Panel Member's Name</p>
    </mat-card>
    <mat-card class="room-details-header-card">
        <p>Room Details</p>
    </mat-card>
</div>    
<div class="feedback-details-content-cards">
    <mat-card class="panel-member-content-card">
        <table mat-table [dataSource]="panelMemberListData" class="mat-elevation-z8">
            <ng-container matColumnDef="position">
                <!-- <th mat-header-cell *matHeaderCellDef> Sl No. </th> -->
                <td mat-cell *matCellDef="let element;let i = index;"> {{i+1}} </td>
            </ng-container>
            <ng-container matColumnDef="fullName">
                <!-- <th mat-header-cell *matHeaderCellDef> Panel Member Name </th> -->
                <td mat-cell *matCellDef="let element"> {{element.panelMemberName}} </td>
            </ng-container>
            <tr mat-row *matRowDef="let row; columns: displayedColumns1;"></tr>
        </table>
    </mat-card>

    <mat-card class="room-details-content-card" style="display: flex;">
        <table style="line-height: 1.5; font-size: 15px;">
            <tr>
                <td class="table-data-height">Corporate Event Name</td>
            </tr>
            <tr>
                <td class="table-data-height">Current Process Name</td>
            </tr>
            <tr class="table-data-height">
                <td>Room Identification</td>
            </tr>
            <tr class="table-data-height">
                <td>Timing</td>
            </tr>
            <br />
            <tr class="table-data-height" *ngIf="meetingLink !== null">
                <td>Meeting Link</td>
            </tr>
        </table>
        <table style="line-height: 1.5; font-size: 15px;">
            <tr class="table-data-height">
                <td><b>:</b> <span style="margin-left: 15px;">{{eventName}}</span></td>
            </tr>
            <tr class="table-data-height">
                <td><b>:</b> <span style="margin-left: 15px;">{{processName}}</span></td>
            </tr>
            <tr class="table-data-height">
                <td><b>:</b> <span style="margin-left: 15px;">{{roomNo}}</span></td>
            </tr>
            <tr class="table-data-height">
                <td><b>:</b> <span style="margin-left: 15px;">{{processStartDate}}</span> <br /><span style="margin-left: 15px;">To {{processEndDate}}</span></td>
            </tr>
            <tr class="table-data-height" *ngIf="meetingLink !== null">
                <td>
                    <b>:</b>
                    <span>
                        <input value={{meetingLink}} class="meeting-link-input-text" />
                    </span>
                    &nbsp;
                    <mat-icon matTooltip="Copy" (click)="copyToClipboard(meetingLink)" svgIcon="copy-to-clipboard" class="meeting-link-copy-icon"></mat-icon>
                    &nbsp;
                    <mat-icon matTooltip="Go To Meeting" (click)="openInNewTab(meetingLink)" svgIcon="open-meeting-in-new-tab" class="meeting-link-open-new-tab-icon"></mat-icon>
                </td>
            </tr>
        </table>
    </mat-card>

</div>



<!-- <div class="mat-toolbar">
    <mat-card-title>Candidate List of {{panelName}}</mat-card-title>
</div>
<mat-grid-list cols="2" rowHeight="150px" gutterSize="2px">
    <mat-grid-tile>
        <div class="example-small-box mat-elevation-z4">
            <mat-card-header>Panel Member's Name</mat-card-header>
            <mat-card-content class="panel-mamber-table">
                <table mat-table [dataSource]="panelMemberListData" class="mat-elevation-z8">
                    -----Position Column-----
                    <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef> Sl No. </th>
                        <td mat-cell *matCellDef="let element;let i = index;"> {{i+1}} </td>
                    </ng-container>
                    ----Name Column----
                    <ng-container matColumnDef="fullName">
                        <th mat-header-cell *matHeaderCellDef> Panel Member Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.panelMemberName}} </td>
                    </ng-container>
                    ----------<tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>---------------
                    <tr mat-row *matRowDef="let row; columns: displayedColumns1;"></tr>
                </table>
            </mat-card-content>
        </div>
    </mat-grid-tile>
    <mat-grid-tile>
        <div class="example-small-box mat-elevation-z4">
            <mat-card-header>Panel Details</mat-card-header>
            <mat-card-content>
                <table>
                    <tr>
                        <td>Corporate Event Name: </td>
                        <td>{{eventName}}</td>
                    </tr>
                    <tr>
                        <td>Current Process Name: </td>
                        <td><b>{{processName}}</b></td>
                    </tr>
                    <tr>
                        <td>Room Identification:</td>
                        <td><b>{{roomNo}}</b></td>
                    </tr>
                    <tr>
                        <td>Timing:</td>
                        <td><b>{{processStartDate}} </b>-- <b style="color: green;">To</b>-- <b> {{ processEndDate}}</b>
                        </td>
                    </tr>
                </table>
            </mat-card-content>
        </div>
    </mat-grid-tile>
</mat-grid-list> -->

<table mat-table [dataSource]="candidateListData" class="mat-elevation-z8" matSort>
    <!-- Position Column -->
    <ng-container matColumnDef="position">
        <th style="font-weight: bold; font-size: 13px;" mat-header-cell *matHeaderCellDef mat-sort-header> Position </th>
        <td style="padding-left: 35px;" mat-cell *matCellDef="let element;let i = index;"> {{i+1}} </td>
    </ng-container>

    <!-- Attendance Selection Column -->
    <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let row">
            <div *ngIf="(row.completeFeedback != 1)">
                <mat-checkbox (change)="$event ? selection.toggle(row) : null"
                    [checked]="row.attendance === 1 ? true : false" [aria-label]="checkboxLabel(row, row.attendance)">
                </mat-checkbox>
            </div>

            <div *ngIf="(row.completeFeedback == 1)">
                <mat-checkbox [checked]=true [disableRipple]="true" (click)="$event.preventDefault()">
                </mat-checkbox>
            </div>
        </td>
    </ng-container>

    <!-- Attedance Status Column -->
    <ng-container matColumnDef="updateAttendance">
        <th style="font-weight: bold; font-size: 13px" mat-header-cell *matHeaderCellDef> Attendance Status </th>
        <td style="padding-left: 20px;" mat-cell *matCellDef="let element">
            <!-- <span *ngIf="element.attendance === 0">---------------</span> -->
            <div *ngIf="element.attendance === 1; else elseBlock">
                <span style="color: green; font-weight: bold;">Present</span>
            </div>
            <ng-template #elseBlock>
                <span style="color: green; font-weight: bold;">Absent</span>
            </ng-template>
        </td>
    </ng-container>

    <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

    <!-- Name Column -->
    <ng-container matColumnDef="candidateName">
        <th style="font-weight: bold; font-size: 13px" mat-header-cell *matHeaderCellDef mat-sort-header> Candidate Name </th>
        <td mat-cell *matCellDef="let element"> {{element.candidateName}} </td>
    </ng-container>

    <!-- CandidateDetails Column -->
    <ng-container matColumnDef="candidateDetails">
        <th style="font-weight: bold; font-size: 13px" mat-header-cell *matHeaderCellDef> Candidate Details </th>
        <td style="padding-left: 20px;" mat-cell *matCellDef="let element">
            <button type="button" mat-mini-fab style="background-color: #252c61;" (click)="openDetails(element.candidateId)">
                <mat-icon>account_circle</mat-icon>
            </button>
        </td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="status">
        <th style="font-weight: bold; font-size: 13px" mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let element">
            <div *ngIf="(element.status != 2 || element.status != 3) && element.completeFeedback != 1 && element.attendance === 1">
                <mat-radio-group (change)="statusChanged($event,element.candidateId)">
                    <mat-radio-button value="2" [checked]="element.status === 2">Selected</mat-radio-button>
                    <mat-radio-button value="3" [checked]="element.status === 3">Rejected</mat-radio-button>
                </mat-radio-group>
            </div>
            <div *ngIf="(element.status === 2) && element.completeFeedback == 1">
                Selected
            </div>
            <div *ngIf="(element.status === 3) && element.completeFeedback == 1">
                Rejected
            </div>
        </td>
    </ng-container>

    <!-- feedback Column -->
    <ng-container matColumnDef="feedback">
        <th style="font-weight: bold; font-size: 13px; padding-left: 45px; width: 135px;"  mat-header-cell *matHeaderCellDef> Feedback </th>
        <td mat-cell *matCellDef="let element;let i = index;">
            <div *ngIf="(element.status != 2 || element.status != 3) && element.completeFeedback != 1">
                <button style="margin-left: 25px;" class="button" type="button" mat-button 
                    (click)="openFeedback(element.candidateId)">Feedback</button>
                <span *ngIf="feedback">{{feedBackMap.get(element.candidateId)}}</span>
            </div>
            <div *ngIf="(element.status == 2 || element.status == 3) && element.completeFeedback == 1">
                <span>{{element.feedback}}</span>
            </div>
        </td>
    </ng-container>

    <!-- Update Column -->
    <ng-container matColumnDef="select1">
        <th style="font-weight: bold; font-size: 13px" mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterToggle1() : null"
                        [checked]="selection1.hasValue() && isAllSelected1()"
                        [indeterminate]="selection1.hasValue() && !isAllSelected1()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? selection1.toggle(row) : null"
                        [checked]="selection1.isSelected(row)">
          </mat-checkbox>
        </td>
      </ng-container>

    <ng-container matColumnDef="action">
        <th style="font-weight: bold; font-size: 13px" mat-header-cell *matHeaderCellDef> Process Completion </th>
        <td mat-cell *matCellDef="let element">
            <div *ngIf="(element.status != 2 || element.status != 3) && element.completeFeedback != 1">
                <button mat-flat-button type="button" style="background-color: #252c61; color: white; margin-left: 30px;"
                    (click)="updateCandidate(element.candidateId)">Update</button>
            </div>
            <div *ngIf="(element.status == 2 || element.status == 3) && element.completeFeedback == 1">
                <span>Status & Feedback Updated</span>
            </div>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns2;" class="example-element-row"></tr>
</table>
<div style="margin-top: 15px; margin-bottom: 10px;">  <!-- *ngIf=showHideLogicAttdenceButton-->
    <button type="button" mat-raised-button style="background-color: #252c61; color: white;" (click)='candidateAttendance()'>Update Attendance</button>
</div>